<template>
  <nav class="nav-sections">
    <a
      v-for="section in sections"
      :key="section.id"
      :href="`#${section.anchorId}`"
      @click.prevent="scrollToSection(section.anchorId)"
      class="nav-link"
    >
      {{ section.nav_title }}
    </a>
  </nav>
</template>

<script setup>
const props = defineProps({
  sections: {
    type: Array,
    required: true,
    default: () => []
  }
});

// Smooth scroll to section
const scrollToSection = (anchorId) => {
  const element = document.getElementById(anchorId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};
</script>

<style scoped>
.nav-sections {
  display: flex;
  gap: 1.5rem;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-feature-settings: "ss01";
}

.nav-link {
  color: var(--mahogany);
  font-size: 1.25cqw;
  counter-increment: link-number;
}

.nav-link::before {
  font-size: 0.75em;
  position: relative;
  bottom: 0.15rem;
  content: counter(link-number);
  margin-right: 0.4em;
  padding-top: 0.08em;
  padding-bottom: 0.14em;
  padding-left: 0.08em;
  padding-right: 0.12em;
  text-align: center;
  width: 1.9ch !important;
  display: inline-block;
  border: 2px solid var(--mahogany-transparent);
  border-radius: 50%;
}

.nav-link:hover::before {
  color: var(--orange);
  background-color: var(--mahogany-transparent);
}



.nav-sections.mobile {
  margin-top: 4rem;
  font-size: 1.125rem;
  font-weight: var(--font-semibold);
  margin-inline: auto;
  height: 13rem;
  width: var(--main-width);
  position: absolute;
  top: 0rem;
  left: 0;
  right: 0;
  z-index: 0;
  border-radius: 4.5rem;
  border-bottom-right-radius: 4rem;
  border-bottom-left-radius: 4rem;
  display: flex;
  justify-content: space-between;
  align-items: end;
  padding: 2rem 4rem;
}
</style>
